import { Col, Row } from 'antd';
import capitalize from 'lodash/capitalize';
import { FC } from 'react';

import { Schemas } from '@api-client/generated/types';
import { IconEditUnderline } from '@assets';
import { BillingRequirementsAlert, CompanyDetailsInfoCell } from '@entities';
import AccountingPlanInfo from '@entities/accounting-plan/AccountingPlanInfo';
import { readBillingSettings } from '@utils';

import * as S from './styled';

type CompanyDetailsServiceProps = {
  company: Schemas.AdminCompanyResponseDto;
  onEdit: () => void;
};

const CompanyDetailsServiceInfo: FC<CompanyDetailsServiceProps> = ({
  company,
  onEdit,
}) => (
  <S.Container>
    <S.Edit onClick={onEdit}>
      <IconEditUnderline width={16} height={16} /> Edit
    </S.Edit>

    <BillingRequirementsAlert company={company} />

    <Row gutter={[20, 0]}>
      <Col span={12}>
        <CompanyDetailsInfoCell
          label="Status"
          value={capitalize(company.status?.split('_').join(' '))}
          isVisible
        />

        <CompanyDetailsInfoCell
          label="Billing"
          value={
            company.billingSettings?.isBillingEnabled ? 'Enabled' : 'Disabled'
          }
          isVisible
        />

        <CompanyDetailsInfoCell
          label="Payslips access"
          value={company.isPayrollEnabled ? 'Enabled' : 'Disabled'}
          isVisible
        />

        <CompanyDetailsInfoCell
          label="Base period price"
          value={company.billingSettings?.baseServicePrice || '-'}
          isVisible
        />

        <AccountingPlanInfo
          companyId={company.id}
          companyName={company.name ?? ''}
        />

        <CompanyDetailsInfoCell
          label="Documents included"
          value={company.billingSettings?.documentsIncluded || '-'}
          isVisible
        />

        <CompanyDetailsInfoCell
          label="Payslip price"
          value={company.billingSettings?.payslipPrice || '-'}
          isVisible
        />

        <CompanyDetailsInfoCell
          label="Payslips amount"
          value={company.billingSettings?.payslipAmount || '-'}
          isVisible
        />

        <CompanyDetailsInfoCell
          label="Intermediation with CCSS and ACD"
          value={
            readBillingSettings(company)?.isCcssAcdIntermediationEnabled
              ? 'Enabled'
              : 'Disabled'
          }
          isVisible
        />

        <CompanyDetailsInfoCell
          label="Intermediation price"
          value={
            readBillingSettings(company)?.ccssAcdIntermediationPrice || '-'
          }
          isVisible={
            readBillingSettings(company)?.isCcssAcdIntermediationEnabled
          }
        />

        <CompanyDetailsInfoCell
          label="Promo code"
          value={company.billingSettings?.promoCode || '-'}
          isVisible
        />
      </Col>
    </Row>
  </S.Container>
);

export default CompanyDetailsServiceInfo;
